import { createSelector } from 'reselect';
import { stateSelector } from '../stateSelector';

export const isBootstrappedSelector = createSelector(
  stateSelector,
  state => state.isBootstrapped,
);
